import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class PageAccessControlService {

  constructor(private http: HttpClient) { }

  url = `${environment.url}/page_access_controls`

  getById(id: number) {
    return this.http.get(`${this.url}?userGroup=${id}`) as Observable<any>;
  }

  get() {
    return this.http.get(this.url) as Observable<any>;
  }
}
